import React from 'react';

const OrderSummary = ({ cart }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 h-fit">
      <h3 className="font-bold text-lg mb-5 pb-3 border-b border-gray-200">Обобщение на поръчката</h3>
      
      <div className="mb-6">
        {cart.items.map((item) => (
          <div key={item.id} className="flex justify-between py-3 border-b border-gray-100 last:border-b-0">
            <div className="flex items-center">
              <span className="bg-gray-200 text-sm rounded-full w-6 h-6 flex items-center justify-center mr-3">
                {item.quantity}
              </span>
              <span className="text-gray-800">{item.name}</span>
            </div>
            <span className="font-medium">{(item.price * item.quantity).toFixed(2)} лв</span>
          </div>
        ))}
      </div>
      
      <div className="space-y-3">
        <div className="flex justify-between">
          <span>Междинна сума</span>
          <span>{cart.subtotal.toFixed(2)} лв</span>
        </div>
        
        {cart.coupon && (
          <div className="flex justify-between text-green-600">
            <span>Отстъпка ({cart.coupon.code})</span>
            <span>-{cart.discountAmount.toFixed(2)} лв</span>
          </div>
        )}
        
        {cart.shippingMethod && (
          <div className="flex justify-between">
            <span>Доставка ({cart.shippingMethod.title})</span>
            <span>{parseFloat(cart.shippingMethod.cost).toFixed(2)} лв</span>
          </div>
        )}
        
        <div className="flex justify-between pt-3 border-t border-gray-200 font-bold text-lg">
          <span>Обща сума</span>
          <span>
            {(
              cart.subtotal - (cart.discountAmount || 0) + 
              (cart.shippingMethod ? parseFloat(cart.shippingMethod.cost) : 0)
            ).toFixed(2)} лв
          </span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary; 